import React from "react";

function JoinDNET() {
  return (
    <div>
      <section className="w-100 float-left position-relative title-con blue-bg py-5">
        <div className="wrapper2">
          <div className="row align-content-center">
            <div className="col-xl-8 col-md-6">
              {" "}
              <div className="generic-title mt-5">
                <h2
                  className="mb-0 aos-init aos-animate px-0"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  Join DNET and Experience the Future of DeFi!
                </h2>
                <div className="d-flex mt-3">
                  <a
                    className="button-1 px-5 my-2 my-lg-0"
                    href="#"
                    data-aos="fade-up"
                    data-aos-duration={600}
                  >
                    <div className="dots_border" />

                    <span className="text_button mb-0">Join Now</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <video
                autoPlay
                loop
                muted
                style={{ height: "100%", width: "100%" }}
              >
                <source
                  src="../assets/images/img/join_dnet_video.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default JoinDNET;
